import React, { useState, useEffect } from 'react';
import { Typography } from '@mui/material';

const VersionStamp = () => {
  const [commitHash, setCommitHash] = useState('');
  const [commitDate, setCommitDate] = useState('');
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    // This will be replaced by the build process
    const hash = process.env.REACT_APP_GIT_COMMIT_HASH || 'local';
    const date = process.env.REACT_APP_GIT_COMMIT_DATE || new Date().toISOString().split('T')[0];
    
    setCommitHash(hash);
    setCommitDate(date);
  }, []);

  return (
    <Typography 
      variant="caption" 
      sx={{ 
        color: isHovered ? '#fff' : '#d4d4b0',
        fontSize: '0.7rem',
        fontFamily: 'monospace',
        transition: 'color 0.2s',
        cursor: 'default',
        userSelect: 'none',
        '&:hover': {
          color: '#fff'
        }
      }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      title={`Commit: ${commitHash}\nDate: ${commitDate}`}
    >
      v{commitHash.substring(0, 7)}
    </Typography>
  );
};

export default VersionStamp;
